import { configureStore } from "@reduxjs/toolkit";
import appSettingsReducer from "./slices/appSettings";

export default configureStore({
    reducer: {
        appSettings: appSettingsReducer
    },
});
